// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>30</span>&nbsp;&nbsp;I have chosen the way of truth&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and your judgements have I laid before me.<br> </p> </div></div>";
// Exports
module.exports = code;